import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

export const useDeleteTSD = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (tsdId: string) => {
      const result = await apiClient.tsd.deleteTsd.mutation({ params: { tsdId } });
      if (result.status !== 204) throw result.body;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['temporary-storages'] });
      toast.success(`Temporary storage deleted!`);
    },
    onError: (error) => {
      showErrorToast(error, `Error deleting the temporary storage!`);
    },
  });
};
